/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';

export interface platformTourState {
  showPlatformTour: boolean;
  showPlatformTourReminder: boolean;
}

const initialState: platformTourState = {
  showPlatformTour: false,
  showPlatformTourReminder: false,
};

export const platformTourSlice = createSlice({
  name: 'platformTour',
  initialState,
  reducers: {
    runTutorial: (state) => {
      state.showPlatformTour = true;
    },
    hideTutorial: (state) => {
      state.showPlatformTour = false;
    },
    showPopupReminder: (state) => {
      state.showPlatformTourReminder = true;
    },
    hidePopupReminder: (state) => {
      state.showPlatformTourReminder = false;
    },
  },
  extraReducers: () => {},
});

export const {
  runTutorial,
  hideTutorial,
  showPopupReminder,
  hidePopupReminder,
} = platformTourSlice.actions;
export const platformTourSelector = (state: RootState) => state.tutorial;
